/** Limit applies before compression, so small archives cannot bypass it. */
export const BOOKING_DOC_MAX_BYTES = 15 * 1024 * 1024;

export async function encodeBookingDocument(bytes: Uint8Array): Promise<{ bytes: Uint8Array; contentEncoding?: 'gzip' }> {
  if (bytes.byteLength >= BOOKING_DOC_MAX_BYTES) throw new Error('Each attachment must be smaller than 15 MiB.');
  if (bytes.byteLength < 256 * 1024 || typeof CompressionStream === 'undefined') return { bytes };
  const compressed = new Uint8Array(await new Response(
    new Blob([new Uint8Array(bytes)]).stream().pipeThrough(new CompressionStream('gzip')),
  ).arrayBuffer());
  return compressed.byteLength <= bytes.byteLength * 0.9
    ? { bytes: compressed, contentEncoding: 'gzip' } : { bytes };
}
